import { FLOOR_OPTIONS } from "@/config/constants";
import { useState, useMemo } from "react";

export const useFloorState = () => {
  const availableFloors = FLOOR_OPTIONS;
  const initialFloor = FLOOR_OPTIONS.find((floor) => floor.id === "main-3") ?? FLOOR_OPTIONS[0];
  const [currentFloorId, setCurrentFloorId] = useState<string>(initialFloor?.id ?? "");

  const currentFloor = useMemo(
    () => availableFloors.find((floor) => floor.id === currentFloorId),
    [availableFloors, currentFloorId],
  );

  const setFloor = (floorId: string) => {
    if (availableFloors.some((floor) => floor.id === floorId)) {
      setCurrentFloorId(floorId);
    }
  };

  const getFloorGeoJsonPath = useMemo(() => {
    return currentFloor?.path ?? initialFloor?.path ?? "/main-1.geojson";
  }, [currentFloor, initialFloor]);

  return {
    currentFloorId,
    availableFloors,
    setFloor,
    getFloorGeoJsonPath,
  };
};
